export enum EChannelsListsUrlType {
  FollowList = 'follow',
  TrendingLists = 'trending',
}
